/*
 * Copyright (c) 2021-2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: mle-combos.ts
 * Project: mle-client
 * Committed last: 2021/11/11 @ 1826
 * ---
 */

import {OSs} from './enums';

export enum CombosNames {
  SWITCH_THEME = 'Cambia tema',
  REPORT_BUG = 'Riporta un bug/feedback',
  SAVE = 'Salva',
  DELETE = 'Elimina selezione',
  COPY = 'Copia',
  PASTE = 'Incolla',
  PASTE_HERE = 'Incolla con posizione cursore',
  DUPLICATE = 'Duplica selezione',
  UNDO = 'Annulla ultima operazione'
}

/**
 * Identifica le scorciatoie disponibili nell'work-area,
 * suddivise per sistema operativo in cui sono supportate.
 * Predisposto per essere utilizzato con accesso tramite indice di tipo string .
 * @example MleCombos.SWITCH_THEME[getOS()]
 */
export const MleCombos = {
  [CombosNames.SWITCH_THEME]: {
    [OSs.WINDOWS]: 'ctrl + alt + T',
    [OSs.LINUX]: 'ctrl + alt + T',
    [OSs.MAC]: 'cmd + option + T'
  },
  [CombosNames.REPORT_BUG]: {
    [OSs.WINDOWS]: 'alt + u',
    [OSs.LINUX]: 'alt + u',
    [OSs.MAC]: 'cmd + u'
  },
  [CombosNames.SAVE]: {
    [OSs.WINDOWS]: 'ctrl + s',
    [OSs.LINUX]: 'ctrl + s',
    [OSs.MAC]: 'cmd + s'
  },
  [CombosNames.DELETE]: {
    [OSs.WINDOWS]: 'del',
    [OSs.LINUX]: 'del',
    [OSs.MAC]: 'backspace'
  },
  [CombosNames.COPY]: {
    [OSs.WINDOWS]: 'ctrl + c',
    [OSs.LINUX]: 'ctrl + c',
    [OSs.MAC]: 'cmd + c'
  },
  [CombosNames.PASTE]: {
    [OSs.WINDOWS]: 'ctrl + v',
    [OSs.LINUX]: 'ctrl + v',
    [OSs.MAC]: 'cmd + v'
  },
  [CombosNames.PASTE_HERE]: {
    [OSs.WINDOWS]: 'ctrl + shift + v',
    [OSs.LINUX]: 'ctrl + shift + v',
    [OSs.MAC]: 'cmd + shift + v'
  },
  [CombosNames.DUPLICATE]: {
    [OSs.WINDOWS]: 'ctrl + d',
    [OSs.LINUX]: 'ctrl + d',
    [OSs.MAC]: 'cmd + d'
  },
  [CombosNames.UNDO]: {
    [OSs.WINDOWS]: 'ctrl + z',
    [OSs.LINUX]: 'ctrl + z',
    [OSs.MAC]: 'cmd + z'
  }
};
